export default class InputHandler {
    constructor(game) {
        this.game = game
        this.keys = []
        this.eligibleForUpdate = true
        this.touchPositionX = 0
        this.touchPositionY = 0

        window.addEventListener('keydown', e => {
            if((e.key === "ArrowUp") && this.keys.indexOf(e.key) === -1) {
                this.keys.push(e.key)
            }
        })
        window.addEventListener('keyup', e => {
            if(e.key === "ArrowUp") {
                this.keys.splice(this.keys.indexOf(e.key), 1)
                this.eligibleForUpdate = true
            }
        })
        // eslint-disable-next-line no-unused-vars
        window.addEventListener('touchstart', e => {
            this.touchPositionX = e.changedTouches[0].clientX
            this.touchPositionY = e.changedTouches[0].clientY
            if(this.keys.indexOf('jump') === -1) {
                this.keys.push('jump')
            }
        })
        // eslint-disable-next-line no-unused-vars
        window.addEventListener('touchend', e => {
            if(this.keys.indexOf('jump') != -1) {
                this.keys.splice(this.keys.indexOf('jump'), 1)
                this.eligibleForUpdate = true
            }
        })
    }
}
